module.exports = __webpack_public_path__ + "img/INTERIOR-IGNIS-2021-1.dbf2c561.jpg";